import { useContext, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { ContentBody, ContentHeader } from 'components/shared/content'
import { ActionTableCell, CheckboxTableRow, ExTable, TableBody, TableCell, TableHead, TableWrapper, useMultipleCheckForm } from 'components/shared/widget'
import { useDownloadCsvEquipmentsApi, useFetchEquipmentsApi } from 'api/equipment'
import { Equipment, EquipmentSearchForm } from 'entities/equipment'
import { Pagination } from 'components/shared/pagination'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { SearchConditionView } from 'components/shared/search_drawer'
import { GlobalStateContext } from 'contexts/global_state_context'
import { equipmentColumnInfoList, EquipmentTableData } from './equipment_table'
import { TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import qs from 'qs'
import { useState } from 'react'
import { EditEquipmentForm, NewEquipmentForm } from './equipment_form'
import { Flex } from 'components/shared/flex'
import { Button } from 'react-bootstrap'
import { NewEquipmentCategoryForm } from 'components/equipment_category/equipment_category_form'

type Props = {
    history: H.History
}

const EquipmentsPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const params = useQuery<EquipmentSearchForm>()
    const searchForm = useForm<EquipmentSearchForm>(params)
    const api = useFetchEquipmentsApi(searchForm)
    const downloadCsvApi = useDownloadCsvEquipmentsApi(searchForm)
    const multipleCheckForm = useMultipleCheckForm<Equipment>()
    const equipmentDisplaySetting = useDisplaySetting(equipmentColumnInfoList(searchForm), 'Equipment')
    const [selectedEquipment, setSelectedEquipment] = useState<Equipment>({})
    const [showEdit, setShowEdit] = useState<boolean>(false)

    useEffect(() => {
        api.execute()
    }, [])

    const handleClickRemoveFilter = (key: keyof EquipmentSearchForm): void => {
        searchForm.update((f) => {
            delete f[key]
        })
    }

    useEffect(() => {
        const queryParams = qs.stringify({ ...searchForm.object, page: api.pageSet.page, perPage: api.pageSet.perPage })
        if (props.history.location.search.replace('?', '') !== queryParams) {
            props.history.replace(`equipments?${queryParams}`)
        }
    }, [searchForm.object])

    const handleClickEdit = (equipment: Equipment) => {
        setSelectedEquipment(equipment)
        setShowEdit(true)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(downloadCsvApi.loading)
    }, [downloadCsvApi.loading])

    return (
        <>
            <EditEquipmentForm
                equipment={selectedEquipment}
                show={showEdit}
                onClose={() => setShowEdit(false)}
                onComplete={() => {
                    api.execute()
                    setShowEdit(false)
                }}
            />

            <ContentHeader
                headerTitle="機器"
                left={
                    <>
                        {/* <CopyTableButton /> */}

                        <NewEquipmentForm
                            onComplete={() => {
                                api.execute()
                            }}
                        />
                        <NewEquipmentCategoryForm></NewEquipmentCategoryForm>
                        <SearchConditionView searchForm={searchForm} onClickRemoveButton={handleClickRemoveFilter} />
                    </>
                }
                right={<>{/* <DisplaySettingModal displaySettings={displaySettings} /> */}</>}
            />
            <Flex style={{ marginTop: 5 }} alignItems="center" justifyContent="space-between">
                <div></div>
                <Flex alignItems="center">
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                    <div style={{ minWidth: 140, textAlign: 'right' }}>総件数： {api.response.count.toLocaleString()}件</div>
                </Flex>
            </Flex>
            <ContentBody>
                <TableWrapper showFooter={multipleCheckForm.form.object.items.length > 0} contentHeaderCount={2}>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <CheckboxTableRow head allCheck allItems={api.response.results} multipleCheckForm={multipleCheckForm} showEdit>
                                <ActionTableCell th width={60} />
                                <TableHeads displaySetting={equipmentDisplaySetting} />
                            </CheckboxTableRow>
                        </TableHead>
                        <TableBody loading={api.loading} columnLength={equipmentDisplaySetting.getColumnLength() + 4}>
                            {api.response.results.map((equipment: Equipment) => {
                                return (
                                    <CheckboxTableRow
                                        key={`equipment-${equipment.id}`}
                                        item={equipment}
                                        multipleCheckForm={multipleCheckForm}
                                        onClickEdit={() => handleClickEdit(equipment)}
                                    >
                                        <ActionTableCell
                                            action="edit"
                                            onClick={() => {
                                                setSelectedEquipment(equipment)
                                                setShowEdit(true)
                                            }}
                                        />
                                        <EquipmentTableData equipment={equipment} displaySetting={equipmentDisplaySetting} />
                                        <TableCell align="center">
                                            {equipment.useTemperatureLedger ? (
                                                <Button
                                                    style={{ width: '100%' }}
                                                    variant="info"
                                                    onClick={() => {
                                                        props.history.push(
                                                            `/ledger/temperature?equipmentId=${equipment.id}&equipmentName=${equipment.name}&equipmentNumber=${equipment.number}`
                                                        )
                                                    }}
                                                >
                                                    温度管理台帳
                                                </Button>
                                            ) : (
                                                <Button
                                                    style={{ width: '100%' }}
                                                    variant="primary"
                                                    onClick={() => {
                                                        props.history.push(
                                                            `/ledgers/maintenance_ledgers?equipmentId=${equipment.id}&equipmentName=${equipment.name}&equipmentNumber=${equipment.number}&equipmentAlias=${equipment.equipmentAlias}`
                                                        )
                                                    }}
                                                >
                                                    保守管理作業日誌
                                                </Button>
                                            )}
                                        </TableCell>
                                    </CheckboxTableRow>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                </TableWrapper>
            </ContentBody>
        </>
    )
}

export default withRouter(EquipmentsPage)
